export const krNav = [
  {
    id: 1,
    name: '회사소개',
    path: '/company',
    sub: [
      { name: '인사말', path: '/company' },
      { name: '약력', path: '/company' },
      { name: '조직도', path: '/company' },
      { name: '특허', path: '/company' },
      { name: '오시는 길', path: '/company' },
    ],
  },
  {
    id: 2,
    name: '제품소개',
    path: '/product',
    sub: [
      { name: 'AeroQbit-D', path: '/product', index: 0 },
      { name: '제품설치 | 설치 장소', path: '/product', group: 'D', index: 1 },
      { name: 'AeroQbit-A', path: '/product', index: 3 },
      { name: '제품설치 | 설치 장소', path: '/product', group: 'A', index: 4 },
    ],
  },
  {
    id: 3,
    name: '기술소개',
    path: '/technology',
    sub: [
      { name: '악취저감시스템', path: '/technology' },
      { name: '축사내부공기순환', path: '/technology' },
      { name: '성능', path: '/technology' },
    ],
  },
  {
    id: 4,
    name: '커뮤니티',
    path: '/community/notice',
    sub: [
      { name: '공지사항', path: '/community/notice' },
      { name: '견적문의', path: '/community/inquiry' },
      { name: '자주묻는질문', path: '/community/faq' },
      { name: 'Q&A', path: '/community/qna' },
      { name: '자료실', path: '/community/archive' },
    ],
  },
];

export const enNav = [
  {
    id: 1,
    name: 'COMPANY',
    path: '/company',
    sub: [
      { name: '인사말_en', path: '/company' },
      { name: '약력_en', path: '/company' },
      { name: '조직도_en', path: '/company' },
      { name: '특허_en', path: '/company' },
      { name: '오시는 길_en', path: '/company' },
    ],
  },
  {
    id: 2,
    name: 'PRODUCT',
    path: '/product',
    sub: [
      { name: 'AeroQbit-D', path: '/product', index: 0 },
      { name: 'Installation | Location', path: '/product', group: 'D', index: 1 },
      { name: 'AeroQbit-D Installation', path: '/product', parent: 'D', index: 1 },
      { name: 'AeroQbit-D Installation Location', path: '/product', parent: 'D', index: 2 },
      { name: 'AeroQbit-A', path: '/product', index: 3 },
      { name: 'Installation | Location', path: '/product', group: 'A', index: 4 },
      { name: 'AeroQbit-A Installation', path: '/product', parent: 'A', index: 4 },
      { name: 'AeroQbit-A Installation Location', path: '/product', parent: 'A', index: 5 },
    ],
  },
  {
    id: 3,
    name: 'TECHNICAL',
    path: '/technical',
    sub: [
      { name: 'TECHNICAL', path: '/' },
      { name: 'TECHNICAL', path: '/' },
      { name: 'TECHNICAL', path: '/' },
    ],
  },
  {
    id: 4,
    name: 'COMMUNITY',
    path: '/community',
    sub: [
      { name: 'Notice', path: '/community/notice' },
      { name: 'Inquiry', path: '/community/inquiry' },
      { name: 'FAQ', path: '/community/faq' },
      { name: 'Q&A', path: '/community/qna' },
      { name: 'Archive', path: '/community/archive' },
    ],
  },
];
